// extracted by mini-css-extract-plugin
export var paginationContainer = "_60-0";